import { useSelector } from "react-redux";
import { AutorizacaoSelector } from "store/Autorizacao/Autorizacao.selector";


export const useAutorizacao = () => {
  return useSelector(AutorizacaoSelector.autorizacao);
}
